import React from "react";

import { makeStyles } from "../../shared/materials/helper";
import ChallanTab from "../../shared/materials/Tab/ChallanTab";
import { analyticsTabMetadata } from "../../../data/metadata/tabsMetadata";

const useStyles = makeStyles((theme) => ({
  container: {
    boxShadow: "0px 16px 56px rgba(54, 43, 115, 0.12)",
    borderRadius: 16,
    margin: theme.spacing(0, 0, 2, 0),
    padding: theme.spacing(2, 4),
  },
  infoContainer: { display: "flex", justifyContent: "space-between" },
  headerContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: theme.spacing(2),
    "& h1": {
      margin: 0,
      fontSize: 22,
      color: "rgba(54, 43, 115, 1)",
      fontWeight: 700,
    },
  },
  label: {
    fontSize: 12,
    color: "rgba(54, 43, 115, 1)",
    fontWeight: 600,
    textAlign: "initial",
    margin: "8px 0px",
  },
  value: {
    fontSize: 20,
    margin: 0,
    marginBottom: 8,
    color: "rgba(54, 43, 115, 1)",
    fontWeight: 700,
    textAlign: "initial",
  },
}));

const AnalyticsBelt = ({ analyticsInfo, analyticsBeltMetadata }) => {
  const [tabIndex, setTabIndex] = React.useState(0);

  const handleTabChange = (_, newValue) => {
    setTabIndex(newValue);
  };
  const classes = useStyles();
  return (
    <div className={classes.container}>
      <div className={classes.headerContainer}>
        <h1>Overview</h1>
        <div>
          <ChallanTab
            config={analyticsTabMetadata()}
            tabIndex={tabIndex}
            onTabChange={handleTabChange}
          />
        </div>
      </div>
      <div className={classes.infoContainer}>
        {analyticsBeltMetadata(analyticsInfo[tabIndex]).map((element) => (
          <div key={element.label}>
            <h1 className={classes.label}>{element.label}</h1>
            <p className={classes.value}>{element.value}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AnalyticsBelt;
